import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Form, FormInput, Text } from 'shared/components'

// Simple options for marketing promotion filter
const marketingOptions = [
  { id: '', name: 'All' },
  { id: 'true', name: 'Yes' },
  { id: 'false', name: 'No' },
];

// Helper functions for select components
const getOptionLabel = option => option.name;
const getOptionValue = option => option.id;

const SponsorsFiltersComponent = ({ form }) => (
  <Form form={form}>
    <Grid>
      <Row middle="xs">
        <Col xs={12} sm={6}>
          <FormInput
            name="search"
            icon="search"
            placeholder="Search by name..."
            grayBg
          />
        </Col>
        <Col xs={12} sm={6}>
          <FormInput
            fluid
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="select"
            name="marketingPromotionSelect"
            placeholder="Marketing Promotion"
            options={marketingOptions}
            oldInput
          />
        </Col>
      </Row>
    </Grid>
  </Form>
)

SponsorsFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
}

export default SponsorsFiltersComponent
